// extracted by mini-css-extract-plugin
export var text = "_50-0";